import React from 'react'
import Container from '../../common/components/Container'

const PageWrapper = Component => props => (
  <div>
    <Container center width="100vw" height="100vh">
      <Component {...props} />
    </Container>
  </div>
)

export {PageWrapper as default}


// WEBPACK FOOTER //
// ./assets/auth/components/PageWrapper.js